module.exports = __webpack_public_path__ + "img/symbol_1.24fba488.png";